import { formatPlayerSchedule } from '../../utility/DateFormatter';
import { EpgEvent, PlayerTimes, StartPositionType } from './StreamInfo';
import { Backend } from '../../../api/Backend';
import { IProperty, IScheduleTime } from '../../../api/models/AndromeTV.types';
import { addProperty } from '../../../api/analytics/AnalyticsUtil';
import { PropertyKeys } from '../../../api/analytics/ClientEvents';

export function getEpgMetaInfo(backend: Backend, schedule: IScheduleTime | undefined): string {
  if (!schedule) return '';
  const startDate = new Date(+schedule.start * 1000);
  const endDate = new Date(+schedule.end * 1000);
  return formatPlayerSchedule(backend, startDate, endDate);
}

export function convertLivePlayerTimes(pos: number, schedule: IScheduleTime | undefined): PlayerTimes {
  if (!schedule) {
    return {
      position: 0,
      duration: 0,
    };
  }
  const current = new Date(pos * 1000);
  const start = new Date(+schedule.start * 1000);
  const end = new Date(+schedule.end * 1000);

  return {
    position: (current.getTime() - start.getTime()) / 1000,
    duration: (end.getTime() - start.getTime()) / 1000,
  };
}

/**
 * Calculate start time for stream. Takes times in miliseconds and returns in seconds.
 */
export function calculateStartTime(start: number, offset = 0): number {
  return (start + offset) / 1000;
}

export function calcEpgStartPosition(
  startPositionType: number,
  event: IScheduleTime | undefined,
  position: number,
  offset: number,
  endOffset: number
): number {
  if (startPositionType === StartPositionType.BOOKMARK) {
    if (event && event.end) {
      const duration = +event.end - +event.start;
      if ((position + offset) / 1000 + endOffset > duration) {
        return Math.max(0, duration - endOffset);
      }
    }
    return calculateStartTime(position, offset);
  } else {
    return calculateStartTime(0, offset);
  }
}

export function epgAnalyticsProperties(epgEvent: EpgEvent, excluded: string[]): IProperty[] {
  const properties: IProperty[] = [];
  addProperty(PropertyKeys.programId, epgEvent.program ? epgEvent.program.id : '', excluded, properties);
  addProperty(PropertyKeys.scheduleId, epgEvent.schedule ? epgEvent.schedule.id : '', excluded, properties);
  addProperty(PropertyKeys.channelId, epgEvent.channel ? epgEvent.channel.channelId : '', excluded, properties);
  addProperty(PropertyKeys.channelName, epgEvent.channel ? epgEvent.channel.text.title : '', excluded, properties);
  return properties;
}
